/*** Development */
export const baseUrl = 'http://167.99.57.16/';
export const apiPath = 'http://165.232.113.213/';

/** Production */
// export const baseUrl = "https://app.greyled.com/";
// export const apiPath = "https://app.greyled.com/";
/** Local */
// export const apiPath = 'http://192.168.0.188:4000/';
